import React from 'react';
import { motion } from 'framer-motion';
type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  align?: 'left' | 'center';
  className?: string;
};
export function SectionHeading({
  eyebrow,
  title,
  align = 'left',
  className = ''
}: SectionHeadingProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.5
  }} className={`${align === 'center' ? 'text-center mx-auto' : 'text-left'} max-w-2xl ${className}`} data-id="element-91">
      <div className={`flex items-center gap-3 mb-4 ${align === 'center' ? 'justify-center' : ''}`} data-id="element-92">
        <p className="font-mono text-xs font-medium text-muted-foreground tracking-[0.2em] uppercase" data-id="element-93">
          {eyebrow}
        </p>
      </div>
      <h2 className="font-heading text-3xl md:text-4xl font-medium tracking-tight text-foreground leading-tight" data-id="element-94">
        {title}
      </h2>
    </motion.div>;
}